import { useState, useRef } from "react"
import { useParams } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'

import Title from '@base/Title'
import Subtitle from '@base/Subtitle'
import BuscaEscola from '@base/Inputs/BuscaEscola'
import Toast from '@base/Toast'

import escolaService from "@services/EscolaService"
import ObjetoPostalService from "@services/ObjetoPostalService"
import AddIcon from '@material-ui/icons/Add'
import ButtonPrimary from "@base/Button"
import CircularProgress from '@material-ui/core/CircularProgress'
import Paper from '@material-ui/core/Paper'
import { ProcessoResolver } from "@helpers/ProcessoHelper"
import { Grid } from '@material-ui/core';
import TextField from '@base/Inputs/Text'
import SelectOption from '@base/Inputs/Select'

import useTipoPendencia from '@hooks/enums/useTipoPendencia';

const useStyles = makeStyles(
	(theme) => (
		{
			wrapper: {
				padding: theme.spacing(2)
			},
			title: {
				color : "#333",
				fontSize: 24,
			}
		}
	)
);

export const RegistrarPendenciasEnvelope = (props) => {
	const [loading, setLoading] = useState(false);
	const [envelope, setEnvelope] = useState({});
  const [tipoPendencia, setTipoPendencia] = useState({});
	const [escola, setEscola] = useState("");
  const [observacoes, setObservacoes] = useState("");

  const params = useParams();
  const processo = ProcessoResolver(params.processo);
  
  const listagemTipoPendencia = useTipoPendencia(params.processo);

	const meuEstilo = useStyles();

	const toastRef = useRef(null);

	const isValido = (obj) => {
		return { ok: true }
	}

	const submit = () => {
		setLoading(true);


		let obj = {
			"processo": processo.id,
			"escola": escola.id,
      "objetoPostal" : envelope.id,
      "tipoPendencia": tipoPendencia,
      "observacoes" : observacoes
		}


		let resultadoValidacao = isValido(obj);
		if (resultadoValidacao.ok) {
			ObjetoPostalService.registrarPendencias(processo.id, obj).then(resultado => {
				toastRef.current.show("success", "Informações de pendências recebidas com sucesso.");
				// verifica DE nao enviado
				// verificaPendenciaDENaoEnviado();
				limparState();

			}).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Salvar as pendências.")).finally(() => {
				setLoading(false);
			});

		} else {
			toastRef.current.show("error", resultadoValidacao.mensagem);
			setLoading(false);
		}
	}

	const limparState = () => {
		setEnvelope({});
		setEscola({});
	}


	const carregaInformacoesDaEscola = (escola) => {
    setEscola(escola);
	  escolaService.buscarDadosDoEnvelope(params.processo, escola.codigoInep).then(resposta => {
			if (resposta.status === 200) {
				setEnvelope(resposta.data);
			} else {
				toastRef.current.show("warning", "Envelope não encontrado.");
				limparState();
			}

		}).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Buscar a Escola."));

	}

	return (
		<>
			<Toast ref={toastRef} />

			<Title>Registrar Pendências</Title>

			{envelope !== undefined && envelope.id !== undefined ?
				<Subtitle>{envelope.nomeEscola}</Subtitle> :
				<BuscaEscola
					size={4}
					autoFocus
					permiteeticket
					processo={processo}
					aoencontrar={carregaInformacoesDaEscola}
					aonaoencontrar={() => {}}
				/>
			}
			<br />

			{escola.id !== undefined &&
				<>
					 <Paper className={meuEstilo.wrapper} spacing={2}>
            <Grid alignItems="center" container spacing={2}>
              <Grid item sm={8} >
                <TextField
                  disabled={true}
                  label="Escola"
                  value={escola.codigoInep + " - " + escola.nome}    />
              </Grid>

              <Grid item sm={4}>
                <TextField
                    disabled={true}
                    label='Numero Objeto Postal'
                    value={envelope.numeroObjetoPostal}
                />
              </Grid>

            </Grid>
            <Grid item container spacing={4}>
             <Grid item sm={12} lg={4}>
              <SelectOption
                label='Pendencia'
                value={tipoPendencia}
                name='tipoPendencia'
                onChange={(e) => setTipoPendencia(e.target.value)}
                options={listagemTipoPendencia.data}
              />
            </Grid>
            </Grid>

            <Grid item container spacing={4}>
             <Grid item sm={12} lg={4}>
             <TextField
                inputProps={{ maxLength: 5000 }}  multiline
                    label='Observaçoes'
                    value={observacoes} onChange={(e) => setObservacoes(e.target.value)}
                />
            </Grid>
            </Grid>



          </Paper>
          <br/>
          <Paper className={meuEstilo.wrapper}>
						<ButtonPrimary
							onClick={submit}
							name="Salvar"
							startIcon={loading ? <CircularProgress size={16} /> : <AddIcon />}
							disabled={loading}
						/>
					</Paper>


				</>
			}
		</>
	);
}

export default RegistrarPendenciasEnvelope;
